// Dropdown click event
document.querySelectorAll('.dropdown__heading').forEach((element, index) => {
  // Find the div for the content
  const dropdownContent = element.parentElement.querySelector('.dropdown__content');
  const dropdownContentContainer = element.parentElement.querySelector('.dropdown__content-container');
  element.addEventListener('click', function () {
    // Initialize the height of the parent, 0 when it's closed
    let initial_height = 0;

    // Check if the dropdown is open
    if (dropdownContent.classList.contains('dropdown__content--visible')) {
      // Remove the classes and set the initial height
      dropdownContentContainer.style.height = initial_height + "px";
      element.classList.toggle('dropdown__heading--active');
      element.parentElement.querySelector('.dropdown__content').classList.toggle('dropdown__content--visible');
    } else {
      // If the element doesn't contain 'active', close all other elements; we skip this loop if we click on the same dropdown to perform a simple toggle
      let active = document.querySelector('.dropdown__heading.dropdown__heading--active');
      if (active != null) {
        active.classList.remove('dropdown__heading--active');
        active.parentElement.querySelector('.dropdown__content').classList.remove('dropdown__content--visible');
        active.parentElement.querySelector('.dropdown__content-container').style.height = initial_height + "px";
      }

      // Add the classes and set the final height
      let final_height = 0 + dropdownContent.clientHeight;
      dropdownContentContainer.style.height = final_height + "px";
      element.classList.toggle('dropdown__heading--active');
      element.parentElement.querySelector('.dropdown__content').classList.toggle('dropdown__content--visible');
    }
  });
});

// When the page is loaded, calculate the open dropdown if there is one to enable the closing transition
window.addEventListener("load", function () {
  const dropdownOpen = document.querySelector('.dropdown__content--visible');
  if (dropdownOpen != null) {
    dropdownOpen.closest(".dropdown__content-container").style.height = dropdownOpen.clientHeight + 'px';
  }
});